<div class="popup__title">
  <ng-content></ng-content>
</div>
